// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"325e6844f031d4cd","3825":"fe3b3a129c453bbb","6181":"5ad0d00c27eb13b3"}[chunkId] + ".css";
};